import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TeamContactDialogComponent} from "./team-contact-dialog.component";
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    TeamContactDialogComponent
  ],
  imports: [
    CommonModule,
    ChappsCommonAngularLibraryModule,
    TranslateModule
  ]
})
export class TeamContactDialogModule {
}
